import Box from '@mui/material/Box';
import { FieldArray, useFormikContext } from 'formik';
import { Dispatch, memo, SetStateAction, useState } from 'react';

import { AirportConfigurationType } from '../../../backend';
import { LeftMenu } from '../../navigation/LeftNavigation/LeftMenu';
import { ConfigurationsPageFormValues } from '../../pages/ConfigurationPage';
import { ConfigurationFieldsLineContainer } from './ConfigurationFieldsLine/ConfigurationFieldsLineContainer';
import { ConfigurationPropertiesMenu } from './ConfigurationPropertiesMenu';

export const ConfigurationFieldsContainer = memo(function ConfigurationFieldsContainer({
    search,
    configurationType,
    setConfigurationType,
}: {
    search: string;
    configurationType: AirportConfigurationType;
    setConfigurationType: Dispatch<SetStateAction<AirportConfigurationType>>;
}) {
    const [selectedConfigurations, setSelectedConfigurations] = useState<number[]>([]);

    const { values, dirty } = useFormikContext<ConfigurationsPageFormValues>();

    const defaultValue =
        values.configurations?.filter(c => c.type === configurationType && c.defaultConfig)?.at(0) || null;

    return (
        <FieldArray
            name="configurations"
            render={({ replace, push, remove }) => (
                <Box display={'flex'} flexDirection={'row'} width={'100%'} height={'100%'} overflow={'hidden'}>
                    <LeftMenu
                        valueType={configurationType}
                        setValueType={setConfigurationType}
                        arrayPush={push}
                        dirty={dirty}
                        defaultValue={defaultValue}
                    />

                    {values && (
                        <Box
                            key={configurationType}
                            display={'flex'}
                            flexDirection={'column'}
                            width={'85%'}
                            height={'100%'}
                            overflow={'hidden'}
                        >
                            <ConfigurationPropertiesMenu
                                configurationType={configurationType}
                                selectedConfigurations={selectedConfigurations}
                                setSelectedConfigurations={setSelectedConfigurations}
                                arrayRemove={remove}
                            />
                            <ConfigurationFieldsLineContainer
                                arrayRemove={remove}
                                arrayReplace={replace}
                                configurationType={configurationType}
                                selectedConfigurations={selectedConfigurations}
                                setSelectedConfigurations={setSelectedConfigurations}
                                search={search}
                            />
                        </Box>
                    )}
                </Box>
            )}
        />
    );
});
